import styled from "styled-components";

export const SplitBillWidgetLottieWrapper = styled.div<{ isClickable?: boolean }>(({ theme, isClickable }) => ({
    position: "relative",
    zIndex: 2,
    /* Lottie has extra padding/margin on left and right; extend and offset to bleed edge-to-edge */
    width: `calc(100% + 2 * ${theme.spacing.medium})`,
    marginLeft: `calc(-1 * ${theme.spacing.medium})`,
    marginRight: `calc(-1 * ${theme.spacing.medium})`,
    lineHeight: 0,
    overflow: "hidden",
    cursor: isClickable ? "pointer" : "default",

    /* LottieAnimation renders a <button> internally */
    button: {
        width: "100%",
        display: "block",
        padding: 0,
        margin: 0,
        border: "none",
        background: "none",
    },

    svg: {
        display: "block",
        width: "100%",
    },
}));
